import React from 'react'
import styles from '../styles.module.scss'
import { FaBookReader } from "react-icons/fa";


const ModesBlock = () => {
  return (
    <div className={styles.modesBlock}>
      <FaBookReader color='#216bd1' size={100}/>
    </div>
  )
}

export default ModesBlock